/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  EditorBlock,
} from 'draft-js';

class Line extends React.Component {
  render () {
    const blockMap = this.props.contentState.getBlockMap().toArray();
    const blockKey = this.props.block.key;
    const lineNumber = blockMap.findIndex(block => blockKey === block.key) + 1;
    return (
      <div style={{ display: 'flex' }}>
        <span style={{ marginRight: '5px' }}>{lineNumber}</span>
        <div style={{ flex: '1' }}><EditorBlock {...this.props} /></div>
      </div>
    );
  }
}

export default Line;




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/Line/index.jsx